import React, { useState, useEffect } from 'react';
import { sanitizeFileName } from '../utils/sanitizeFileName';
import { MSG } from "../constants/toastMessages";
import { IoCloseOutline } from "react-icons/io5";
import { CiFileOn } from "react-icons/ci";
import { toast } from 'react-toastify';
import { apiCallingPost } from "../api/services";
import axios from "axios";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";

let validFiles = [];

function VideoMultipleUpload(props) {
  let [cloudFolderName, configData, cloudBucketName, file_folder] = []
  const [files, setFiles] = useState([]);
  const [showListFlag, setShowListFlag] = useState(false);
  const [buttonData, setButtonData] = useState("Upload And Save");
  const [uploadProgress, setUploadProgress] = useState({}); // Track progress for each file
  const [isDragOver, setIsDragOver] = useState(false);
  const [signedUrls, setSignedUrls] = useState({});
  const [isImporting, setIsImporting] = useState("");
  const [offLineFlag, setOffLineFlag] = useState("");
  const [isUploadFlag, setIsUploadFlag] = useState(true)
  const [destinationFileDate, setDestinationFileDate] = useState("");
  const [destinationFileLocation, setDestinationFileLocation] = useState([]);
  const [eventNameList, setEventNameList] = useState([]);
  const [selectedEventName, setSelectedEventName] = useState(null);
  const [folderType, setFolderType] = useState("");
  const [selectedLocationName, setSelectedLocationName] = useState(null);

  useEffect(() => {
    setIsUploadFlag(true)
    getLocationNameList()
    getEventNameList()
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };

    const handleOffline = () => {
      toast.error(MSG.offlineUploadPaused);
      setOffLineFlag(true)
    };

    const handleOnline = () => {
      toast.success(MSG.backOnline);
      setOffLineFlag(true)
      resumeUpload();
    };

    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("online", resumeUpload);
    };
  }, []);
  //   useEffect(() => {
  //     if(validFiles.length > 0){
  //       setShowListFlag(false)
  //     }

  // }, [validFiles]);
  const getEventNameList = () => {
    apiCallingPost("api/common/get_all_events").then((data) => {
      if (data.data.success === "1") {
        const events = data.data.result.events || [];
        const formatted = events.map((c) => ({ value: c, label: c }));
        setEventNameList(formatted);

      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };
  const getLocationNameList = () => {
    apiCallingPost("api/common/get_all_locations").then((data) => {
    //  console.log("...data..get_all_locations...", data);

      if (data.data.success === "1") {
        const Locations = data.data.result.Locations || [];
        const formatted = Locations.map((c) => ({ value: c, label: c }));
        setDestinationFileLocation(formatted);

      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };
  const resumeUpload = () => {
    const storedUpload = JSON.parse(localStorage.getItem("pending_upload"));
    if (storedUpload && storedUpload.length > 0) {
      const newUploadProgress = {};
      const filesFromStorage = storedUpload.map((stored) => {
        const matchingFile = validFiles.find((file) => file.name === stored.fileName);
        if (matchingFile) {
          return matchingFile;
        }
        return null;
      }).filter(Boolean);
      setFiles(filesFromStorage);
      setShowListFlag(true);
      // Resume uploads for each file
      storedUpload.forEach((storedFile) => {
        const matchingFile = filesFromStorage.find((file) => file.name === storedFile.fileName);
        if (matchingFile) {
          if (storedFile.success) {
            newUploadProgress[storedFile.fileName] = "Success";
          } else {
            const progress = Math.round((storedFile.progress / storedFile.size) * 100);
            newUploadProgress[storedFile.fileName] = `${progress}%`;
            // Resume upload from last saved position
            uploadChunks(
              matchingFile,
              storedFile.filePath,
              storedFile.url,
              storedFile.progress
            );
          }
        }
      });
      setUploadProgress(newUploadProgress);
    }
  };

  const handleDrop = async (event) => {
    // validFiles = []
    event.preventDefault();
    setIsDragOver(false);
    const droppedFiles = Array.from(event.dataTransfer.files);
    validFiles = await handleFileValidation(droppedFiles);
    if (validFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setShowListFlag(true);
    } else {
      toast.error(MSG.noValidFiles);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleFileValidation = async (selectedFiles) => {
    let validFiles = [];
    for (const file of selectedFiles) {
      validFiles.push(file);
    }
    return validFiles;
  };

  const handleFileSelection = async (event) => {

    setButtonData("Upload And Save");
    localStorage.removeItem("pending_upload");
    setSignedUrls({})
    setUploadProgress({})
    const selectedFile = Array.from(event.target.files);
    event.target.value = null;
    validFiles = [];
    let pendingUploads = [];

    for (const file of selectedFile) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (file.type.startsWith("video/") || ["mxf"].includes(extension)) {
        try {
          validFiles.push(file);
          pendingUploads.push({
            fileName: file.name,
            fileType: "2", // video type
            progress: 0,
            success: false,
            size: file.size,
            validated: true,
            // Do not include the file object here
          });
        } catch (error) {
          toast.error(error);
        }
      } else if (file.type.startsWith("image/")) {

        validFiles.push(file);
        pendingUploads.push({
          fileName: file.name,
          fileType: "1", // image type
          progress: 0,
          success: false,
          size: file.size,
          validated: true,
          // Do not include the file object here
        });
      } else {
        toast.error(`${file.name} is not a valid video or image file.`);
      }
    }
    if (validFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setShowListFlag(true);
      localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));
    }
  };

  const processFileUpload = async (file, index) => {
    try {
      let signedUrl = signedUrls[file.name];
      let filePath;
      let result;

      if (!signedUrl) {
        let fileName = sanitizeFileName(file?.name);
        const dotIndex = fileName.lastIndexOf(".");
        const namePart = fileName.substring(0, dotIndex);
        const extension = fileName.substring(dotIndex);
        fileName = `${namePart}_${new Date().getTime()}${extension}`;
        [cloudFolderName, configData, cloudBucketName, file_folder] = [
          props.getCloudBucketData.find(item => item.id === 7)?.config_value,
          props.getCloudBucketData.find(item => item.id === 14)?.config_value,
          props.getCloudBucketData.find(item => item.id === 5)?.config_value,
          props.getCloudBucketData.find(item => item.id === 18)?.config_value
        ];

        const eventName = selectedEventName?.value ? "/Events/" + selectedEventName?.value : ""
        const locationName = selectedLocationName?.value ? "/Locations/" + selectedLocationName?.value : ""
        filePath = `${cloudFolderName}/${configData}/${file_folder}${eventName ? eventName : locationName}/${fileName}`;
        const postData = { fileName: filePath };
        const response = await apiCallingPost("api/common/generateResumableUrl", postData);

        if (response.data.success === "1") {
          result = response.data.result;
          signedUrl = result.signedUrl;
          const extension = file.name.split(".").pop().toLowerCase();
          setSignedUrls((prev) => ({ ...prev, [file.name]: signedUrl }));
          return {
            fileName: file.name,
            filePath,
            progress: 0,
            cloudBucketName: cloudBucketName,
            url: result,
            size: file.size,
            fileType: file.type.startsWith("video/") || ["mxf"].includes(extension) ? "2" : "1",
            validated: true,
          };
        } else {
          throw new Error("Failed to generate signed URL.");
        }
      }
    } catch (error) {
      toast.error(`Error processing ${file.name}: ${error.message}`);
      throw error; // Re-throw the error to handle it in the calling function
    }
  };

  const importData = async () => {
    setIsImporting("true"); // Indicate the upload has started
    setButtonData("Uploading...")
    const newUploadProgress = {};
    validFiles.forEach((file) => {
      newUploadProgress[file.name] = "Uploading...";
    });
    setUploadProgress(newUploadProgress);

    try {
      // Generate signed URLs for all files first
      const pendingUploads = await Promise.all(validFiles.map((file, index) => processFileUpload(file, index)));
      // Set pending_upload in localStorage after all signed URLs are generated
      localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));
      uploadData()

      // Upload the main file to cloud storage
      await Promise.all(pendingUploads.map((data, index) => uploadChunks(validFiles[index], data.filePath, data.url, 0)));
    } catch (error) {
      setIsImporting("true");
      toast.error(`Unexpected error during import: ${error.message}`);
    }
  };
  const uploadChunks = async (file, filePath, uploadUrl, startByte = 0) => {
    let progress = "";
    const CHUNK_SIZE = 5 * 1024 * 1024;
    if (file.size <= CHUNK_SIZE) {

      try {

        await axios.put(uploadUrl.signedUrl, file, {
          headers: { "Content-Type": file.type },
          onUploadProgress: ({ loaded, total }) => {
            progress = Math.round((loaded * 100) / total);

            setUploadProgress((prev) => ({ ...prev, [file.name]: `${progress}%` }));
          },
        });

        let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];
        pendingUploads = pendingUploads.map((item) => {

          if (item.fileName === file.name) {
            setUploadProgress((prev) => ({ ...prev, [file.name]: "Success" }));
            return {
              ...item,
              progress: file.size,
              progressPercentage: progress,
              success: progress === 100,
              size: file.size // Ensure size is stored
            };
          }
          return item;
        });

        localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));
        checkAllUploadsComplete();
      } catch (error) {

        if (!navigator.onLine) {
          return;
        }
        setUploadProgress((prev) => ({ ...prev, [file.name]: "Failed" }));
        toast.error(`Error uploading ${file.name}: ${error.message}`);
        return;
      }
    }

    else {
      let start = startByte;
      while (start < file.size) {
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunkBlob = file.slice(start, end);
        try {
          const res = await fetch(uploadUrl.signedUrl, {
            method: "PUT",
            headers: {
              "Content-Type": "application/octet-stream",
              "Content-Range": `bytes ${start}-${end - 1}/${file.size}`,
            },
            body: chunkBlob,
          });

          if (res.ok || res.status === 308) {
            start = end;
            progress = Math.round((start / file.size) * 100);
            setUploadProgress((prev) => ({ ...prev, [file.name]: `${progress}%` }));

            // Update storage after each successful chunk
            let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];

            pendingUploads = pendingUploads.map((item) => {
              if (item.fileName === file.name) {
                item.size === start && setUploadProgress((prev) => ({ ...prev, [file.name]: "Success" }));
                return {
                  ...item,
                  progress: start,
                  progressPercentage: progress,
                  success: progress === 100,
                  size: file.size // Ensure size is stored
                };
              }
              return item;
            });

            localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));
            // if (pendingUploads.progress === pendingUploads.size) {
            //   setUploadProgress((prev) => ({ ...prev, [file.name]: "loading..." }));
            // }
            checkAllUploadsComplete();
          } else {
            throw new Error(`Upload failed: ${res.statusText}`);
          }
        } catch (error) {
          if (!navigator.onLine) {
            return;
          }
          setUploadProgress((prev) => ({ ...prev, [file.name]: "Failed" }));
          toast.error(`Error uploading ${file.name}: ${error.message}`);
          return;
        }
      }
    }
  };
  const checkAllUploadsComplete = () => {
    let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];

    const allUploaded = pendingUploads.every((file) => file.progress === file.size && file.success === true);

    if (allUploaded) {

      setButtonData("Loading...")
      toast.success(MSG.dataUploaded);
      setTimeout(() => {
        cancelPopup()
      }, 1000);
      props.videoListFn()
      localStorage.removeItem("pending_upload")
      // uploadData()
    }
  };
  const uploadData = async () => {
    const pendingUploads = JSON.parse(localStorage.getItem("pending_upload") || "[]");

    let videoUrl = []; // Initialize as an array
    let fileTitle = "";
    for (const data of pendingUploads) {
      fileTitle = data.fileName.substring(0, data.fileName.lastIndexOf("."));
      const cloudStorageLink = "https://storage.googleapis.com"
      const result = {
        videoUrl: `${cloudStorageLink}/${data.cloudBucketName}/${data.filePath}`,
        fileTypeId: data.fileType,
        fileName: fileTitle,
      };
      videoUrl.push(result); // Push the result into the array
    }
    if (videoUrl?.[0] == null || videoUrl?.[0] == undefined) {
      // Handle the case where no valid URLs were generated
      // toast.warn(MSG.selectFiles)
      //setShowListFlag(false);
    } else {
      SaveData(videoUrl);
    }
  };

  const SaveData = async (videoUrlArray) => {

    const postData = {
      videoName: "",
      videoUrl: videoUrlArray,
      userId: props.userData.userId,
      createdBy: props.userData.userId,
      videoDescription: "",
      processedBy: props.userData.userId,
      roleName: props.userData.roleDisplayName,
      videoLocation: selectedLocationName?.value,
      videoDate: destinationFileDate ? moment((destinationFileDate)).format('YYYY-MM-DD') : "",
      eventName: selectedEventName?.value
    };

    try {
      apiCallingPost("api/video/uploadVideo", postData);
    } catch (error) {
      toast.error(`Error uploading data: ${error.message}`);
    }

  }

  const deleteFile = (data, index) => {

    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setUploadProgress((prev) => {
      const updatedProgress = { ...prev };
      delete updatedProgress[index];
      return updatedProgress;
    });
    let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];
    pendingUploads = pendingUploads.filter((upload, i) => i !== index);
    validFiles = validFiles.filter((upload, i) => i !== index);

    localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));



  };

  const clickEvent = () => {
    if (buttonData == "Upload And Save") {
      importData()
    }
  }

  const cancelPopup = () => {
    setShowListFlag(false);
    setFiles([])
    setUploadProgress({})
    setIsUploadFlag(props.isDragFile)
    props.setIsDragFile(false)
  }
  const handleChange = (selected) => {
    setSelectedEventName(selected);
  };
  const handleLocationChange = (selected) => {
    setSelectedLocationName(selected);
  };
  const handleInputChange = (inputValue, { action }) => {
    if (action === "input-change") {
      // while typing, store as selected
      setSelectedEventName({ value: inputValue, label: inputValue });
    }
  };
  const handleInputLocationChange = (inputValue, { action }) => {
    if (action === "input-change") {
      // while typing, store as selected
      setSelectedLocationName({ value: inputValue, label: inputValue });
    }
  };
  return (
    <>


      {/* <div style={{display : isUploadFlag ? 'block' : 'none'}} className="modal-admin-wrapper multiple-upload">
        <div className="modal-ad-popup modal-md"> */}

      {(showListFlag && validFiles.length > 0) ? (
        <div className="modal-admin-wrapper multiple-upload " >

          <div className="modal-ad-popup modal-md">
            <div className="modal-innerpopup">
              <div className="modal-headdiv d-flex justify-content-between">
                <h5 className="modal-head">Import Files</h5>
                <span className="closeBtn">
                  <IoCloseOutline onClick={() => cancelPopup()} size={32} />
                </span>
              </div>
              <div className="modal-admin-body my-3" style={{
                overflowX: 'hidden'
              }}>
                <div className="mutliple-upload-files" style={{
                  maxHeight: 'calc(100vh - 290px)',
                  overflowY: 'auto',
                  overflowX: 'hidden'
                }}>
                  {files.map((file, index) => (
                    <div className="row my-1 mx-0 border-line" key={index}>
                      <div className="col-8 col-lg-9">
                        <div className="d-flex align-items-center file-name">
                          <CiFileOn fontSize={23} className='file-ico ms-0' />
                          <span className="file-names">{file.name}</span>
                        </div>
                      </div>
                      <div className="col-4 col-lg-3 d-flex align-items-center justify-content-end">
                        {uploadProgress[file.name] ? (
                          <div className={`file-size me-3 text-primary text-sm ${uploadProgress[file.name] === "Failed"
                            ? "text-danger"
                            : uploadProgress[file.name] === "Success"
                              ? "text-success"
                              : ""
                            }`}>
                            {uploadProgress[file.name]}
                          </div>
                        )
                          : (
                            <IoCloseOutline size={20} onClick={() => deleteFile(file, index)} />
                          )
                        }
                      </div>
                    </div>
                  ))}

                </div>

              </div>
              <div className="text-end">
                <button className="btn btn-primary" onClick={clickEvent} id="Save"
                  disabled={buttonData === "Uploading..." || buttonData === "Loading..."}>
                  {buttonData}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        isUploadFlag && (
          <div style={{ display: isUploadFlag ? 'block' : 'none' }} className="modal-admin-wrapper multiple-upload add-admin">

            <div className="modal-ad-popup modal-md">


              <div className="row">

                <div className='col-md-4'>
                  <select class="form-select form-register-popup" value={folderType} onChange={(e) => setFolderType(e.target.value)} >
                    <option value="">Select type</option>
                    <option value="Event Name">Event Name</option>
                    <option value="Location Name">Location Name</option>

                  </select>
                </div>
                <div className='col-md-4'>
                  <div className="form_div mb-3">
                    {(folderType === "Event Name") ?
                      <CreatableSelect
                        options={eventNameList}
                        value={selectedEventName}
                        onChange={handleChange}
                        onInputChange={handleInputChange}
                        placeholder="Event name"
                        isClearable={false}
                        isSearchable
                        classNamePrefix="select"
                        classNames={{
                          control: () => 'px-3',
                        }}
                        formatCreateLabel={(inputValue) => `${inputValue}`} // custom text when typing
                      />
                      : (folderType === "Location Name") ?
                        <CreatableSelect
                          options={destinationFileLocation}
                          value={selectedLocationName}
                          onChange={handleLocationChange}
                          onInputChange={handleInputLocationChange}
                          placeholder="Location name"
                          isClearable={false}
                          isSearchable
                          classNamePrefix="select"
                          classNames={{
                            control: () => 'px-3',
                          }}
                          formatCreateLabel={(inputValue) => `${inputValue}`} // custom text when typing
                        /> :
                        <input type='text'
                          className='form-register-popup mb-0'
                          placeholder="Event/Location"
                          disabled={true} />
                    }


                  </div>
                </div>
                {/* <div className="col-4">
                  <input type="text" className='form-register-popup' placeholder='Location' onChange={(e) => setDestinationFileLocation(e.target.value)} />
                </div> */}
                <div className='col-md-4'>
                  {/* <input type="text" className='form-register-popup' placeholder='Date' onChange={(e) => setDestinationFileDate(e.target.value)} /> */}
                  <DatePicker selected={destinationFileDate} className='form-register-popup' placeholderText="Date"
                    dateFormat="dd-MM-yyyy"
                    onChange={(date) => {
                      setDestinationFileDate(date)
                    }} calendarClassName="custom-calendar"
                    renderCustomHeader={({
                      date,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div className="custom-header">
                        <div className="custom-header-top">
                          <div className="day">
                            {date.toLocaleDateString("en-US", {
                              weekday: "short",
                              month: "short",
                              day: "numeric",
                            })}
                          </div>
                        </div>
                        <div className="custom-month-nav">

                          <span className="month-year">
                            {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
                          </span>
                          <div>
                            <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker">
                              <MdKeyboardArrowLeft color="#fff" size={25} />
                            </span>
                            <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker">
                              <MdOutlineKeyboardArrowRight color="#fff" size={25} />
                            </span>
                          </div>

                        </div>
                      </div>
                    )} />
                </div>
              </div>
              <div className={`file-upload-list ${isDragOver ? 'drag-over' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}>
                <span className="closeBtn  closeBtn_file">
                  <IoCloseOutline onClick={() => cancelPopup()} size={26} />
                </span>
                <div className="box__input">
                  <input
                    type="file"
                    name="files[]"
                    id="file"
                    className="box__file"
                    multiple
                    onChange={(e) => { handleFileSelection(e) }}
                  />
                  <label htmlFor="file">
                    <span>Drag Files</span>
                    <span className="box__dragndrop">
                      <div>Or</div>
                      <span className='text-underline'> Click To Upload</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>))}
      {/* </div>
      </div> */}

    </>
  );
}

export default VideoMultipleUpload;
